import useReveal from './useReveal';

const services = [
  {
    num: '01',
    title: 'Mechanical Engineering',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </svg>
    ),
    items: [
      'Fabrication and supply of steel structures',
      'Maintenance and plant upgrades',
      'Extension of underground conveyor systems',
      'HDPE and steel piping solutions',
    ],
  },
  {
    num: '02',
    title: 'Civil Engineering',
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="3" y="3" width="18" height="18" />
        <path d="M3 9h18M9 3v18" />
      </svg>
    ),
    items: [
      'Construction of concrete slabs and platforms',
      'Site preparation and earthworks',
      'Structural renovations and installations',
      'Bridges and general road works',
    ],
  },
  {
    num: '03',
    title: 'Project & Programme Management',
    icon: (
      <svg viewBox="0 0 24 24">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
    items: [
      'End-to-end project lifecycle management',
      'Stakeholder coordination and reporting',
      'Compliance and quality assurance',
    ],
  },
  {
    num: '04',
    title: 'Mining Services',
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
      </svg>
    ),
    items: [
      'Infrastructure development for mining operations',
      'Supply and installation of industrial components',
      'Renovation of change houses and ablution facilities',
      'Fencing and security infrastructure',
    ],
  },
];

export default function Services() {
  const topRef = useReveal();
  const gridRef = useReveal();

  return (
    <section id="services">
      <div className="svc-top reveal" ref={topRef}>
        <div>
          <div className="eyebrow">What We Do</div>
          <h2 className="sec-title">Core<br />Services</h2>
        </div>
        <p>
          From steel fabrication to civil construction, our skilled teams deliver hands-on technical
          expertise across the mining, industrial, and infrastructure sectors with precision and professionalism.
        </p>
      </div>

      <div className="svc-grid reveal" ref={gridRef}>
        {services.map(s => (
          <div className="svc-card" key={s.num}>
            <span className="svc-num">{s.num}</span>
            <div className="svc-icon">{s.icon}</div>
            <h3>{s.title}</h3>
            <ul>
              {s.items.map(item => <li key={item}>{item}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
